import React, { FC } from 'react';
import { IModalWrapperProps } from '../modal';

const ModalHeader: FC<IModalWrapperProps> = (props: Partial<IModalWrapperProps>) => {
  const headerText = props.headerText || '';
  const defaultHeaderLayout = <>
    {headerText}
    <span className='btn-close' aria-hidden='true' onClick={props.cancelAction}>×</span>
  </>;

  return (
    <div className='modal-header'>
      {props.customHeader || defaultHeaderLayout}
    </div>
  );
};

export default ModalHeader;
